import { useEffect, useState } from "react";
import { lookupEmail } from "@/services/auth.service";

export function useEmailLookup(email) {
  const [state, setState] = useState({ checking: false, valid: false, exists: false, self: false, name: null });

  useEffect(() => {
    const clean = (email || "").trim().toLowerCase();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(clean)) {
      setState({ checking: false, valid: false, exists: false, self: false, name: null });
      return;
    }
    let cancelled = false;
    setState((s) => ({ ...s, checking: true }));
    const t = setTimeout(async () => {
      try {
        const res = await lookupEmail(clean);
        if (!cancelled) setState({ checking: false, ...res });
      } catch {
        if (!cancelled) setState({ checking: false, valid: true, exists: false, self: false, name: null });
      }
    }, 400);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [email]);

  return state;
}
